// extracted by mini-css-extract-plugin
export default {"infoContainer":"InfoTile_infoContainer__Ik+Zd","infoLabel":"InfoTile_infoLabel__OdhrQ","infoValue":"InfoTile_infoValue__mtHQK"};